
import Vue from "vue";
import { Watch } from "vue-property-decorator";

export default abstract class ThemeUpdatingView extends Vue {

  /**
   * 👂 Listener for changes in the flag for whether dark mode is enabled
   */
  @Watch("$store.state.userPreferences.darkMode")
  private onDarkModeChanged(val: boolean, oldVal: boolean) {
    this.themeUpdate();
  }

  /**
   * 🏗 Function which should be called once the app theme changes
   */
  protected abstract themeUpdate(): void;
}
